import { Controller, useFormContext } from 'react-hook-form';
import { realisation as rules } from 'further-ui/validations';
import AppCheckbox from 'components/FormElements/AppCheckBox';
import { numberToCurrencyString } from 'further-ui/utils';
import SectionedTable from 'components/SectionedTable';
import { CurrencyCode } from 'further-types/lp/vehicle';

type Props = {
  currency: CurrencyCode;
  disabled: boolean;
};

const WithholdingTaxExemptTable: React.FC<Props> = ({ currency, disabled }) => {
  const { control, watch } =
    useFormContext<rules.CreateRealisationFormValues>();
  const investorWithholdingTaxList = watch('investorWithholdingTaxList') || [];

  const columns = [
    {
      key: 'label',
      label: 'Investor',
    },
    {
      key: 'totalCommitmentLcy',
      label: 'Total commitment',
      render: (row) =>
        numberToCurrencyString(row.totalCommitmentLcy, { currency }),
    },
    {
      key: 'withholdingTax',
      label: 'Exempt',
      render: (row) => (
        <Controller
          control={control}
          name={`investorWithholdingTaxList.${row.index}.withholdingTaxExempt`}
          render={({ field }) => (
            <AppCheckbox
              name={`investorWithholdingTaxList.${row.index}.withholdingTaxExempt`}
              checked={field.value}
              onChange={(e) => {
                field.onChange(e.target.checked);
              }}
              disabled={disabled}
            />
          )}
        />
      ),
    },
  ];

  const rows = investorWithholdingTaxList.map((item, index) => ({
    ...item,
    key: item.commitmentId,
    label: item.investorName,
    group: 'Investors',
    index,
  }));

  return (
    <SectionedTable
      columns={columns}
      rows={rows}
      title="Withholding tax exempt investors"
      centerTitle={true}
      headerColor="white"
      hasGroupPadding={false}
      showSeparator={false}
    />
  );
};

export default WithholdingTaxExemptTable;
